(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const one = (selector, scope = document) => scope.querySelector(selector);
  const all = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  const escapeHtml = (value) => String(value || "").replace(/[&<>"']/g, (character) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" })[character]);
  const money = (cents, currency = "KWD") => new Intl.NumberFormat("ar-KW", { style: "currency", currency, minimumFractionDigits: currency === "KWD" ? 3 : 2 }).format((cents || 0) / 100);

  const cartLayer = one("[data-cart-layer]");
  const cartItems = one("[data-cart-items]");
  const cartSummary = one("[data-cart-summary]");
  const cartTotal = one("[data-cart-total]");
  const courseModal = one("[data-course-modal]");
  let modalVariantId = "";
  let lockedScrollY = 0;
  let activeCategory = "الكل";
  let activeSearch = "";

  function setScrollLock() {
    const shouldLock = Boolean((cartLayer && !cartLayer.hidden) || (courseModal && !courseModal.hidden));
    const isLocked = document.body.classList.contains("najem-no-scroll");
    if (shouldLock && !isLocked) {
      lockedScrollY = window.scrollY;
      document.body.style.top = `-${lockedScrollY}px`;
      document.body.classList.add("najem-no-scroll");
    } else if (!shouldLock && isLocked) {
      document.body.classList.remove("najem-no-scroll");
      document.body.style.top = "";
      const originalScrollBehavior = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = "auto";
      window.scrollTo(0, lockedScrollY);
      requestAnimationFrame(() => { document.documentElement.style.scrollBehavior = originalScrollBehavior; });
    }
  }

  function openCart() {
    if (!cartLayer) return;
    cartLayer.hidden = false;
    setScrollLock();
    refreshCart();
  }

  function closeCart() {
    if (!cartLayer) return;
    cartLayer.hidden = true;
    setScrollLock();
  }

  async function refreshCart() {
    try {
      const response = await fetch(root + "cart.js", { headers: { Accept: "application/json" } });
      const cart = await response.json();
      all("[data-cart-count]").forEach((element) => { element.textContent = cart.item_count; });
      if (!cartItems || !cartSummary) return;
      if (!cart.items.length) {
        cartItems.innerHTML = '<div class="najem-empty-cart"><svg class="najem-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 4h2l2.1 10.1a2 2 0 0 0 2 1.6h7.8a2 2 0 0 0 1.9-1.5L20 8H6"/><circle cx="10" cy="20" r="1"/><circle cx="18" cy="20" r="1"/></svg><b>ابدأ باختيار مادتك</b><p>جميع الكورسات تشمل الملخص المترجم والمحاضرات والنماذج المحلولة.</p><a href="' + root + '#NajemCourses" data-cart-shop>استعرض الكورسات</a></div>';
        cartSummary.hidden = true;
        one("[data-cart-shop]", cartItems)?.addEventListener("click", closeCart);
        return;
      }
      cartItems.innerHTML = cart.items.map((item) => '<article class="najem-cart-item">' +
        (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="">' : "") +
        '<div><b>' + escapeHtml(item.product_title) + '</b><small dir="ltr">' + escapeHtml(item.sku || "") + '</small><strong dir="ltr">' + escapeHtml(money(item.final_line_price, cart.currency)) + '</strong></div>' +
        '<button type="button" data-remove-key="' + escapeHtml(item.key) + '">حذف</button></article>').join("");
      cartSummary.hidden = false;
      if (cartTotal) cartTotal.textContent = money(cart.total_price, cart.currency);
      all("[data-remove-key]", cartItems).forEach((button) => button.addEventListener("click", () => changeCart(button.dataset.removeKey, 0)));
    } catch {
      if (cartItems) cartItems.innerHTML = '<p>تعذر تحديث السلة الآن. حاول مرة أخرى.</p>';
    }
  }

  async function changeCart(key, quantity) {
    await fetch(root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity })
    });
    refreshCart();
  }

  async function addVariant(variantId) {
    if (!variantId) return false;
    const response = await fetch(root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    });
    if (!response.ok) throw new Error("Cart add failed");
    closeCourseModal();
    openCart();
    return true;
  }

  function applyCourseFilters() {
    const cards = all("[data-course-card]");
    if (!cards.length) return;
    let visible = 0;
    const term = activeSearch.trim().toLowerCase();
    cards.forEach((card) => {
      const categoryMatch = activeCategory === "الكل" || card.dataset.category === activeCategory;
      const searchMatch = !term || (card.dataset.search || "").includes(term);
      const show = categoryMatch && searchMatch;
      card.hidden = !show;
      if (show) visible += 1;
    });
    const empty = one("[data-empty-results]");
    if (empty) empty.hidden = visible !== 0;
    const summary = one("[data-results-summary]");
    if (summary) {
      summary.hidden = !term;
      summary.textContent = term ? "نتائج البحث — " + visible + " مواد" : "";
    }
  }

  function openCourseModal(card) {
    if (!courseModal || !card) return;
    one("[data-modal-image]", courseModal).src = card.dataset.image || "";
    one("[data-modal-code]", courseModal).textContent = card.dataset.code || "";
    one("[data-modal-title]", courseModal).textContent = card.dataset.title || "";
    one("[data-modal-english]", courseModal).textContent = (card.dataset.code || "") + " — " + (card.dataset.english || "");
    one("[data-modal-description]", courseModal).textContent = card.dataset.description || "";
    one("[data-modal-category]", courseModal).textContent = card.dataset.category || "";
    one("[data-modal-price]", courseModal).textContent = card.dataset.price || "15.000 د.ك";
    modalVariantId = card.dataset.variantId || "";
    const addButton = one("[data-modal-add]", courseModal);
    const unlinked = one("[data-product-unlinked]", courseModal);
    if (addButton) {
      addButton.disabled = !modalVariantId;
      addButton.textContent = "اشترك الآن";
    }
    if (unlinked) unlinked.hidden = true;
    courseModal.hidden = false;
    setScrollLock();
  }

  function closeCourseModal() {
    if (!courseModal) return;
    courseModal.hidden = true;
    modalVariantId = "";
    setScrollLock();
  }

  document.addEventListener("DOMContentLoaded", () => {
    all("[data-menu-toggle]").forEach((button) => button.addEventListener("click", () => {
      const nav = one("[data-mobile-nav]");
      const open = nav && !nav.classList.contains("open");
      nav?.classList.toggle("open", open);
      button.setAttribute("aria-expanded", String(Boolean(open)));
    }));
    all("[data-mobile-nav] a").forEach((link) => link.addEventListener("click", () => one("[data-mobile-nav]")?.classList.remove("open")));

    all("[data-search-toggle]").forEach((button) => button.addEventListener("click", () => {
      const panel = one("[data-search-panel]");
      if (!panel) return;
      panel.hidden = !panel.hidden;
      button.setAttribute("aria-expanded", String(!panel.hidden));
      if (!panel.hidden) one("[data-course-search]", panel)?.focus();
    }));
    all("[data-course-search]").forEach((input) => input.addEventListener("input", () => {
      activeSearch = input.value;
      applyCourseFilters();
    }));
    all("[data-search-submit]").forEach((link) => link.addEventListener("click", () => {
      const panel = one("[data-search-panel]");
      if (panel) panel.hidden = true;
    }));

    all("[data-course-filter]").forEach((button) => button.addEventListener("click", () => {
      activeCategory = button.dataset.courseFilter || "الكل";
      all("[data-course-filter]").forEach((item) => item.classList.toggle("selected", item === button));
      applyCourseFilters();
    }));
    all("[data-reset-courses]").forEach((button) => button.addEventListener("click", () => {
      activeCategory = "الكل";
      activeSearch = "";
      all("[data-course-filter]").forEach((item) => item.classList.toggle("selected", item.dataset.courseFilter === "الكل"));
      all("[data-course-search]").forEach((input) => { input.value = ""; });
      applyCourseFilters();
    }));

    all("[data-course-open]").forEach((button) => button.addEventListener("click", () => openCourseModal(button.closest("[data-course-card]"))));
    one("[data-course-close]")?.addEventListener("click", closeCourseModal);
    one("[data-modal-add]")?.addEventListener("click", async () => {
      try { await addVariant(modalVariantId); } catch { alert("تعذر إضافة الكورس إلى السلة. حاول مرة أخرى."); }
    });
    courseModal?.addEventListener("mousedown", (event) => { if (event.target === courseModal) closeCourseModal(); });

    all("[data-cart-open]").forEach((button) => button.addEventListener("click", openCart));
    all("[data-cart-close]").forEach((button) => button.addEventListener("click", closeCart));
    cartLayer?.addEventListener("mousedown", (event) => { if (event.target === cartLayer) closeCart(); });

    all('[data-type="ajax-cart"]').forEach((form) => form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const id = new FormData(form).get("id");
      try { await addVariant(String(id || "")); } catch { form.submit(); }
    }));

    one("[data-discount-apply]")?.addEventListener("click", () => {
      const input = one("[data-discount-input]");
      const message = one("[data-discount-message]");
      const code = (input?.value || "").trim().toUpperCase();
      if (!message) return;
      if (code === "WELCOME10") {
        message.textContent = "سيتم تطبيق خصم 10% عند الانتقال للدفع.";
        message.style.color = "#14864d";
      } else if (code) {
        message.textContent = "سيتم التحقق من الكود في صفحة الدفع.";
        message.style.color = "#68798d";
      } else {
        message.textContent = "اكتب كود الخصم أولًا.";
        message.style.color = "#a94242";
      }
    });
    one("[data-checkout]")?.addEventListener("click", () => {
      const code = (one("[data-discount-input]")?.value || "").trim();
      window.location.href = code ? root + "discount/" + encodeURIComponent(code) + "?redirect=/checkout" : root + "checkout";
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeCart();
        closeCourseModal();
        const panel = one("[data-search-panel]");
        if (panel) panel.hidden = true;
      }
    });
    refreshCart();
  });
})();
